import { ActionIcon, Box, Group, Stack, Text } from '@mantine/core'
import { IconChevronLeft } from '@tabler/icons-react'
import styles from './Titlebar.module.css'
import { TitlebarProps } from './types'

export function Titlebar({
  title,
  subtitle,
  onBack,
  rightSection,
  showBackButton = true,
  isVisible = true,
}: TitlebarProps) {
  return (
    <Box
      className={`${styles.titlebar} ${!isVisible ? styles.titlebarHidden : ''}`}
    >
      <Group justify="space-between" wrap="nowrap">
        <Group gap="md" wrap="nowrap">
          {showBackButton && onBack && (
            <ActionIcon
              variant="subtle"
              color="gray"
              onClick={onBack}
              size="lg"
              aria-label="Takaisin"
            >
              <IconChevronLeft size={24} />
            </ActionIcon>
          )}
          <Stack gap={0}>
            <Text fw={600} size="lg">
              {title}
            </Text>
            {subtitle && (
              <Text size="xs" c="dimmed">
                {subtitle}
              </Text>
            )}
          </Stack>
        </Group>
        {rightSection}
      </Group>
    </Box>
  )
}

export type { TitlebarProps } from './types'
